export default "__VITE_ASSET__02bdf0b5__"